<template>
  <div>
    <component id="header" v-if="headerComponentName" :is="headerComponentName" @logout="logout" ></component>
  <!-- Image and text -->

  </div>


</template>

<script>
  import {dd,store,app} from 'systems/imports'

  import PCHeader from "components/global/partials/LoggedInHeader/PCHeader.vue"
  import MobileHeader from "components/global/partials/LoggedInHeader/MobileHeader.vue"

  export default {
    components: {
      PCHeader,
      MobileHeader,
    },
    data () {
      return {
      }
    },
    computed:{
      headerComponentName(){
        switch(this.$root.bootstrapBreakpoint){
          case "xl":
          case "lg":
            return "PCHeader"
          case "md":
          case "sm":
          case "xs":
            return "MobileHeader"
          default:
            return null
        }
      },
      userName(){
        let user = store.get("user")
        return `${user.family_name} ${user.given_name}`
      }
    },
    mounted(){

    },
    methods: {
      logout(){
        this.$emit('logout')
      }
    }
  }
</script>
<style lang="scss" scoped>





</style>



// WEBPACK FOOTER //
// LoggedInHeader.vue?35352084